import Honeybadger from "@honeybadger-io/js"

import { AppError } from "./AppError"

export class InvalidDataError<TData> extends AppError {
  data: TData
  issues?: unknown

  constructor(message: string, args: { data: TData; issues?: unknown }) {
    super(message)
    this.name = "InvalidDataError"
    this.data = args.data
    this.issues = args.issues
  }

  notify() {
    Honeybadger.notify(this, {
      name: this.name,
      message: this.message,
      stack: this.stack,
      // Without this, all validation failures share the same minified
      // backtrace and are grouped into a single Honeybadger fault.
      fingerprint: `${this.name}: ${this.message}`,
      params: {
        data: this.data,
        issues: this.issues
      }
    })
  }
}
